angular.module('widget').controller('tcMainCtrl', [
	'$scope',
	'$location',
	'$pusher',
	'dataFactory',
	'tgConfig',
	'$q',
	'$interval',
	'tgClock',
	'$window',
	'twReservationManager',
	'tgTranslate',
	'$sce',
	function (
		$scope,
		$location,
		$pusher,
		dataFactory,
		tgConfig,
		$q,
		$interval,
		tgClock,
		$window,
		twReservationManager,
		tgTranslate,
		$sce
	) {
		$scope.customer = {}
		$scope.reservation = {}
		$scope.origin = null
		$scope.groupReservationMinPartySize = 8 //Default value
		$scope.groupReservationMaxPartySize = 30 //Default value
		$scope.groupReservationPartySizeOptions = []
		$scope.noteHtml = null
		$scope.lang = 'pt'
		$scope.isCelebrationsBenefitSelected = false
		var hourI18nString = 'hora'
		var minuteI18nString = 'minuto'
		var timestampReservationStatus = null
		var availabilitiesObject = null

		function isDateAvailable(date) {
			if (_.isEmpty(availabilitiesObject) || _.isEmpty(availabilitiesObject.availabilities)) return true
			var dateObj = _.find(availabilitiesObject.availabilities, function (dateObj) {
				return date == dateObj.reservationDay
			})
			if (!dateObj || dateObj.available) return true
			return false
		}

		function dateDisabled(obj) {
			if (obj.mode != 'day') return false
			return !isDateAvailable(moment.utc(obj.date).format('YYYY-MM-DD'))
		}

		// function customDateClass(obj) {
		//     if(obj.mode != 'day') return;
		//     if (!isDateAvailable(moment.utc(obj.date).format('YYYY-MM-DD'))) return 'no-vacancy';
		// };

		//Safari/Firefox fix (check tgDatePicker directive for more info)
		function fixDateTimeForDST(dateTime) {
			if (!dateTime || !moment.isMoment(dateTime)) return null

			if (dateTime.hour() == 23) return moment(dateTime).add(1, 'days').hour(1)
			return dateTime
		}

		var cardUrlPattern = /\/card$/
		var tosUrlPattern = /\/terms$/
		var customerUrlPattern = /\/customer$/
		$scope.showBackButton = function () {
			if ($location.path().match(cardUrlPattern) || $location.path().match(customerUrlPattern)) {
				return true
			}

			return false
		}

		$scope.goBack = function () {
			var isFromCardUrl = $location.path().match(cardUrlPattern)
			var isFromTermsUrl = $location.path().match(tosUrlPattern)
			if (isFromCardUrl || isFromTermsUrl) {
				var path = 'widget/' + $scope.venueId + '/'
				var searchTerms = {
					customer: $scope.customer._id,
					origin: $scope.origin.label,
				}
				if ($scope.operator) searchTerms.operator = $scope.operator
				if ($scope.isCelebrations) searchTerms.isCelebrations = 'true'
				$location.path(path).search(searchTerms)
			} else {
				var path = '/widget/' + $scope.venueId
				$location.path(path)
			}

			init()
		}

		$scope.getHeaderTitle = function () {
			if ($location.path().match(cardUrlPattern)) {
				return 'Qual cartão você vai usar?'
			} else if ($location.path().match(customerUrlPattern)) {
				return 'Your contact info'
			} else {
				return 'Online reservations'
			}
		}

		$scope.selectDate = function () {
			if (!twReservationManager.getReservationSettings()) {
				return
			}

			$scope.sections = null
			$scope.partySizes = null
			$scope.reservationTimes = null
			$scope.isReservationTimeFull = false
			var preSelectedSection = $scope.reservation.selectedSection
			var preSelectedPartySize = $scope.reservation.selectedPartySize
			var preSelectedReservationTime = $scope.reservation.selectedReservationTime
			$scope.reservation.selectedSection = null
			$scope.reservation.selectedPartySize = null
			$scope.reservation.selectedReservationTime = null

			fillSectionOptions(preSelectedSection, preSelectedPartySize, preSelectedReservationTime)
		}

		$scope.selectSection = function (section, preSelectedPartySize, preSelectedReservationTime) {
			var widgetGroupReservationsEnabled =
				_.get(twReservationManager.getReservationSettings('widgetGroupReservations'), 'enabled') &&
				$scope.origin.label != 'Bradesco'

			$scope.partySizes = null
			$scope.reservationTimes = null
			$scope.isReservationTimeFull =
				(!widgetGroupReservationsEnabled && section.availability.length == 0) ||
				(widgetGroupReservationsEnabled &&
					section.availability.length == 0 &&
					section.groupAvailability.length == 0)
			$scope.reservation.selectedSection = section
			$scope.reservation.selectedType = null
			$scope.reservation.selectedPartySize = null
			$scope.reservation.selectedReservationTime = null

			if (!$scope.isReservationTimeFull)
				fillPartySizeOptions(section, preSelectedPartySize, preSelectedReservationTime)
		}

		$scope.selectPartySize = function (partySize, preSelectedReservationTime) {
			$scope.reservationTimes = null
			$scope.isReservationTimeFull = !partySize.reservationTimes || partySize.reservationTimes.length == 0
			$scope.reservation.selectedPartySize = partySize
			$scope.reservation.selectedReservationTime = null

			if (!$scope.isReservationTimeFull) fillReservationTimeOptions(partySize, preSelectedReservationTime)
		}

		$scope.selectReservationTime = function (reservationTime) {
			$scope.reservation.selectedReservationTime = reservationTime
		}

		$scope.confirmarReserva = function (_customerCard, _vipTable, _invalid) {
			var customer = {}
			var isBradescoRequest = !!(_customerCard || $scope.origin.label === 'Bradesco')

			// Bradesco validation
			if (isBradescoRequest) {
				var braSelectedCard = _customerCard
				if (!braSelectedCard) return // User must select a card (is this an error? is there any card available?)
				if (!braSelectedCard.isAccepted) return // Cannot make a reservation with a card that is not accepted.
				if (braSelectedCard.hasChoice && !$scope.selectedBenefit) return // User must choose one benefit

				// Setting the selected benefit id on the customer card object
				if (braSelectedCard.hasChoice) _customerCard.selectedBenefit = $scope.customerCardBenefit.benefit._id

				// Ensure card is set on global variable
				$scope.customerCardReservation = braSelectedCard
			}
			if (_invalid) return

			if ($scope.customer.nome) {
				var nameArray = $scope.customer.nome.split(' ')
				if (nameArray.length < 2) {
					// $scope.requireLastName = true;
					$scope.loader = false
					return
				}

				customer.name = nameArray[0]
				customer.lastName = ''
				for (var i = 1; i < nameArray.length; i++) {
					var namePart = nameArray[i]
					customer.lastName += namePart + ' '
				}
				customer.lastName = customer.lastName.trim()
			}

			if ($scope.customer.cpf) customer.cpf = $scope.customer.cpf

			$scope.loader = true
			dataFactory
				.getCustomer($scope.customer._id, $scope.customer.telefone, $scope.customer.email)
				.then(function (_customers) {
					if (_customers && _customers.data && _customers.data.length > 0) {
						customer._id = _customers.data[0]._id
						customer.name = _customers.data[0].name
						customer.lastName = _customers.data[0].lastName
						customer.phone = _customers.data[0].phone
						customer.email = _customers.data[0].email
						customer.venues = _customers.data[0].venues
					} else {
						customer.phone = $scope.customer.telefone
						customer.email = $scope.customer.email
					}

					var reservation = {
						partySize: $scope.reservation.selectedPartySize,
						section: $scope.reservation.selectedSection,
						reservationDay: $scope.reservation.reservationDate,
						reservationTime: $scope.reservation.selectedReservationTime,
						timestamp: timestampReservationStatus,
						note: $scope.reservation.obs,
						type: $scope.reservation.selectedPartySize.type,
						benefits: $scope.customerCardReservation ? $scope.customerCardReservation : '',
						lang: $scope.lang,
					}

					if (
						reservation.benefits &&
						reservation.benefits.avatarUrl &&
						reservation.benefits.avatarUrl.length > 0
					) {
						reservation.benefits.avatarUrl = reservation.benefits.avatarUrl.replace(tgConfig.imageUrl, '')
					}

					dataFactory
						.setReservation(
							$scope.venueId,
							customer,
							reservation,
							$scope.origin,
							$scope.operator,
							isBradescoRequest
						)
						.then(function (response) {
							// console.log('reservation', JSON.stringify(response.data, null, 4));

							// Showing new reservation voucher for concierges or celebrations
							var voucherNumber = _.get(response, 'data.voucher')
							if (isBradescoRequest && voucherNumber) {
								$scope.voucher = voucherNumber
							}

							var path = 'widget/' + $scope.venueId + '/success'
							$location.path(path)
							//$location.path(path).search({customer: $scope.customer._id, origin: $scope.origin.label, operator: $scope.operator})
						})
						.catch(function (response) {
							var error = _.get(response, 'data.error')
							$scope.reservation.errorReservation = true
							console.log('Error while saving reservation:', response)

							var errorMessage = _.get(response, 'data.message')
							if (errorMessage) alert(errorMessage)
						})
						.finally(function () {
							$scope.loader = false
							$scope.selectedBenefit = false
						})
				})
				.catch(function (response) {
					console.log('Error while searching customer:', response)
					$scope.loader = false
				})
		}

		$scope.termosCondicoes = function (_customerCard) {
			$scope.storedCustomerCardWhileOnTermsAndConditionsScreen = _customerCard
			$scope.bradescoCelebrationsRegulamentoUrl = $sce.trustAsResourceUrl(
				dataFactory.getBradescoCelebrationsTermsConditionsUrl()
			)

			$window.scrollTo(0, 0)
			var path = 'widget/' + $scope.venueId + '/terms'
			$location
				.path(path)
				.search({ customer: $scope.customer._id, origin: $scope.origin.label, operator: $scope.operator })
		}

		$scope.acceptTos = function () {
			var customerCard = $scope.storedCustomerCardWhileOnTermsAndConditionsScreen
			$scope.storedCustomerCardWhileOnTermsAndConditionsScreen = null
			$scope.confirmarReserva(customerCard)
		}

		$scope.backReserva = function () {
			$scope.reservation.errorReservation = false
			$window.history.back()
		}

		$scope.clearRadio = function (_cardBenefits, _cardHasChoice) {
			if (!_cardHasChoice) return // Nothing to clear if there are no radios on screen

			$scope.selectedBenefit = false
			_cardBenefits.forEach(function (_benefit) {
				_benefit.radioCheck = false
			})
			//console.log('_cardBenefits', JSON.stringify(_cardBenefits, null, 4));
		}

		$scope.getBenefit = function (_customerCard, _benefit) {
			$scope.customerCardReservation = _customerCard

			$scope.customerCardBenefit = _benefit

			$scope.selectedBenefit = true

			// If benefit is Celebrations, the user must first accept the terms and conditions
			if ($scope.isCelebrations) {
				$scope.isCelebrationsBenefitSelected = true
			} else {
				var CONST_CELEBRATIONS_BENEFIT_ID = '5bd225dc8caf7a3e36d94848'
				var selectedBenefitId = _.get(_benefit, 'benefit._id')
				$scope.isCelebrationsBenefitSelected = selectedBenefitId === CONST_CELEBRATIONS_BENEFIT_ID
			}

			// console.log('$scope.customerCardReservation', JSON.stringify($scope.customerCardReservation, null, 4));
			// console.log('$scope.customerCardBenefit', JSON.stringify($scope.customerCardBenefit, null, 4));
		}

		$scope.prosseguirReserva = function (_origin, _customerId, _operator) {
			if (!$scope.reservationPickerProceedEnabled()) return

			var isBradescoRequest = _origin === 'Bradesco'
			if (isBradescoRequest && _customerId) {
				if (!$scope.isReservationOn || !$scope.reservation.selectedReservationTime) {
					return
				}
				$window.scrollTo(0, 0)

				// If we are on a strictly celebrations request, force selection of Celebrations benefits (will soon deprecate)
				if ($scope.isCelebrations) $scope.isCelebrationsBenefitSelected = true

				var path = 'widget/' + $scope.venueId + '/card'
				$location.path(path).search({ customer: _customerId, origin: _origin, operator: _operator })
			} else {
				if (!$scope.isReservationOn || !$scope.reservation.selectedReservationTime) {
					return
				}
				$window.scrollTo(0, 0)
				var path = 'widget/' + $scope.venueId + '/customer'
				$location.path(path)
			}
		}

		function fillSectionOptions(preSelectedSection, preSelectedPartySize, preSelectedReservationTime) {
			if (
				!$scope.reservation.reservationDate ||
				_.isEmpty(availabilitiesObject) ||
				_.isEmpty(availabilitiesObject.availabilities) ||
				!availabilitiesObject.available
			) {
				$scope.isReservationTimeFull = true
				return
			}

			var reservationDayMoment = fixDateTimeForDST(
				moment.tz($scope.reservation.reservationDate, 'America/Sao_Paulo')
			)
			var dayObject = _.find(availabilitiesObject.availabilities, function (dayObject) {
				if (dayObject.available && dayObject.reservationDay == reservationDayMoment.format('YYYY-MM-DD'))
					return true
				return false
			})

			if (!dayObject) {
				$scope.isReservationTimeFull = true
				return
			}

			$scope.isReservationTimeFull = false
			timestampReservationStatus = dayObject.timestamp
			$scope.sections = buildSectionsWithVacancy(dayObject.sections)

			if (preSelectedSection) {
				var availablePreSelectedSection = _.find($scope.sections, { id: preSelectedSection.id })
				// console.log('availablePreSelectedSection', _.get(availablePreSelectedSection, 'label'))
				if (availablePreSelectedSection)
					$scope.selectSection(availablePreSelectedSection, preSelectedPartySize, preSelectedReservationTime)
			}
		}

		function buildSectionsWithVacancy(sections) {
			if (!sections || sections.length == 0) return null

			var widgetGroupReservationsEnabled =
				_.get(twReservationManager.getReservationSettings('widgetGroupReservations'), 'enabled') &&
				$scope.origin.label != 'Bradesco'

			return _.filter(sections, function (section) {
				var groupTimesAvailable =
					section.groupSchedules &&
					section.groupSchedules.length > 0 &&
					_.find(section.groupSchedules, { available: true })
				var regularPartySizesAvailable =
					section.schedules && section.schedules.length > 0 && _.find(section.schedules, { available: true })

				if (widgetGroupReservationsEnabled && !groupTimesAvailable && !regularPartySizesAvailable)
					return false
				if (!widgetGroupReservationsEnabled && !regularPartySizesAvailable) return false

				//Removes partySizes without vacancy
				section.availability = _.filter(section.schedules, function (partySize) {
					if (!partySize.available) return false

					//Remove reservationTimes without vacancy
					partySize.reservationTimes = _.filter(partySize.reservationTimes, function (reservationTime) {
						return reservationTime.available
					})

					return true
				})

				if (widgetGroupReservationsEnabled) {
					section.groupAvailability = _.filter(section.groupSchedules, function (reservationTime) {
						return reservationTime.available
					})
				}

				if (
					widgetGroupReservationsEnabled &&
					(!section.groupAvailability || section.groupAvailability.length == 0) &&
					(!section.availability || section.availability.length == 0)
				)
					return false
				if (!widgetGroupReservationsEnabled && (!section.availability || section.availability.length == 0))
					return false

				return true
			})
		}

		function fillPartySizeOptions(section, preSelectedPartySize, preSelectedReservationTime) {
			$scope.partySizes = []

			if (section.availability && section.availability.length > 0) {
				$scope.partySizes = _.map(section.availability, function (availabilityIterator) {
					var partySize = _.cloneDeep(availabilityIterator)
					partySize.name = buildPartySizeOptionName(partySize.partySize)

					partySize.type = 'Regular'
					return partySize
				})
			}

			var widgetGroupReservationsEnabled =
				_.get(twReservationManager.getReservationSettings('widgetGroupReservations'), 'enabled') &&
				$scope.origin.label != 'Bradesco'
			if (
				widgetGroupReservationsEnabled &&
				section.groupAvailability &&
				section.groupAvailability.length > 0
			) {
				$scope.partySizes.push({
					name: 'Reservas para grupos',
					type: 'Group',
					reservationTimes: _.cloneDeep(section.groupAvailability),
				})
			}

			if (preSelectedPartySize && $scope.partySizes && $scope.partySizes.length > 0) {
				var availablePreSelectedPartySize = null
				if (preSelectedPartySize.type == 'Regular') {
					availablePreSelectedPartySize = _.find($scope.partySizes, {
						partySize: preSelectedPartySize.partySize,
					})
				} else if (preSelectedPartySize.type == 'Group') {
					availablePreSelectedPartySize = _.find($scope.partySizes, { type: 'Group' })
					if (availablePreSelectedPartySize && preSelectedPartySize.partySize)
						availablePreSelectedPartySize.partySize = preSelectedPartySize.partySize
				}

				if (availablePreSelectedPartySize)
					$scope.selectPartySize(availablePreSelectedPartySize, preSelectedReservationTime)
			}
		}

		function fillReservationTimeOptions(partySize, preSelectedReservationTime) {
			$scope.reservationTimes = _.map(partySize.reservationTimes, function (timeIterator) {
				return timeIterator.reservationTime
			})
			$scope.isReservationTimeFull = partySize.reservationTimes.length == 0

			if (preSelectedReservationTime && $scope.reservationTimes && $scope.reservationTimes.length > 0) {
				var preSelectedReservationTimeIndex = $scope.reservationTimes.indexOf(preSelectedReservationTime)
				if (preSelectedReservationTimeIndex >= 0) $scope.selectReservationTime(preSelectedReservationTime)
			}
		}

		function getApps() {
			if ($scope.origin == 'Phone' || $scope.origin == 'Widget') {
				$scope.origin = {
					label: $scope.origin,
				}
			} else {
				var arrayApp = twReservationManager.getReservationAppsOptions()
				var normalizedOrigin = $scope.origin.toLowerCase() == 'michelin' ? 'Guia Michelin' : $scope.origin

				var appOrigin = _.find(arrayApp, { name: normalizedOrigin })

				$scope.origin = {
					app: appOrigin.value,
					label: appOrigin.name,
				}
			}
		}

		$scope.getHumanizedDuration = function (durationInMinutes) {
			if (!durationInMinutes || durationInMinutes < 0) return ''

			if (durationInMinutes % 60 == 0) {
				var hoursCount = durationInMinutes / 60
				return hoursCount + (hoursCount > 1 ? ' ' + hourI18nString + 's' : ' ' + hourI18nString)
			} else {
				return durationInMinutes + ' ' + minuteI18nString + 's'
			}
		}

		$scope.reservationPickerProceedEnabled = function () {
			if (!$scope.isReservationOn) return false
			if (_.get($scope, 'reservation.selectedPartySize.type') == 'Group') {
				var partySize = _.get($scope, 'reservation.selectedPartySize.partySize')
				if (
					!partySize ||
					partySize < $scope.groupReservationMinPartySize ||
					partySize > $scope.groupReservationMaxPartySize
				)
					return false
			}
			if (!_.get($scope, 'reservation.selectedReservationTime')) return false

			return true
		}

		function buildPartySizeOptions(minPartySize, maxPartySize) {
			if (!minPartySize) minPartySize = 8
			if (!maxPartySize) maxPartySize = 30

			if (maxPartySize < minPartySize) return []

			var partySizeOptions = []
			for (var i = minPartySize; i <= maxPartySize; i++) {
				partySizeOptions.push({ partySize: i, name: buildPartySizeOptionName(i) })
			}

			return partySizeOptions
		}

		function init() {
			$scope.loader = true
			$scope.renderDatepicker = false
			$scope.reservationWidgetApp = null
			availabilitiesObject = null
			$scope.noteHtml = null
			$scope.lang = 'pt'
			hourI18nString = 'hora'
			minuteI18nString = 'minuto'
			peopleI18nString = 'pessoa'

			$scope.customer._id = $location.search().customer ? $location.search().customer : null
			if ($location.search().fullName && $location.search().fullName.length > 0)
				$scope.customer.nome = $location.search().fullName.toString()
			if ($location.search().phone && $location.search().phone.length > 0)
				$scope.customer.telefone = $location
					.search()
					.phone.toString()
					.replace(/[^0-9]/g, '')
			if ($location.search().email && $location.search().email.length > 0)
				$scope.customer.email = $location
					.search()
					.email.toString()
					.replace(/[^0-9A-Za-z.@]/g, '')
					.toLowerCase()
			if ($location.search().cpf && $location.search().cpf.length > 0) {
				$scope.customer.cpf = $location
					.search()
					.cpf.toString()
					.replace(/[^0-9]/g, '')
				if ($scope.customer.cpf.length !== 11) delete $scope.customer.cpf
			}

			$scope.origin = $location.search().origin ? $location.search().origin : 'Widget'
			$scope.operator = $location.search().operator ? $location.search().operator : null
			$scope.isCelebrations = $location.search().isCelebrations
				? $location.search().isCelebrations === 'true'
				: false
			$scope.reservation.obs = ''
			$scope.reservation.errorReservation = false //verifica se a reserva ainda está disponível quando clicar em confirmar
			$scope.reservation.errorReservationOn = false //reservas desabilitadas para o estabelecimento
			$scope.reservation.disableReservationOn = false //desabilitar calendário e botões de dropdown
			$scope.selectedBenefit = false
			var urlParts = $location.path().split('/')
			$scope.venueId = urlParts[2]
			$scope.reservation.selectedSection = null
			$scope.reservation.selectedPartySize = null
			$scope.reservation.selectedReservationTime = null
			$scope.reservationTimes = null
			timestampReservationStatus = null
			// $scope.requireLastName = false;
			$scope.isReservationTimeFull = false //mensagem quando não disponibilidade de horários para a seleção
			$scope.minReservationAntecedence = null

			var promises = {
				getReservationSeats: dataFactory.getReservationSeats($scope.venueId),
				getReservationWidgetApp: dataFactory.getReservationWidgetApp($scope.venueId),
			}
			var isBradescoRequest = $scope.origin === 'Bradesco'
			if (isBradescoRequest) {
				promises.getCardsBenefitsForVenue = dataFactory.getCardsBenefitsForVenue(
					$scope.customer._id,
					$scope.venueId,
					$scope.operator,
					$scope.isCelebrations
				)
			}

			$q.all(promises)
				.then(function (resolved) {
					if (isBradescoRequest) {
						$scope.customerCards = resolved.getCardsBenefitsForVenue.data

						_.forEach($scope.customerCards, function (card) {
							// Treating the cards benefits, looking for possible choices (e.g.: valet OR discount)
							var treatedCardBenefits = []
							_.forEach(card.benefits, function (benefitValue) {
								var choicesIndicator = benefitValue['$or']
								if (!choicesIndicator) return treatedCardBenefits.push(benefitValue) // No need to treat

								// Card has benefits to be chosen
								card.hasChoice = true
								_.forEach(choicesIndicator, function (choiceBenefit) {
									// If this is a single benefit, just add it pronto
									if (!choiceBenefit.length) {
										choiceBenefit.isChoice = true
										treatedCardBenefits.push(choiceBenefit)
										return
									}

									// If there are multiple items inside the choice, add them up in a single element
									// This may be changed later if a better layout is found
									var syntheticBenefit = {
										benefit: {
											descript: {
												pt: '',
											},
											_id: 'noncelebrationsBenefit',
										},
										isChoice: true,
									}
									var allBenefitsDescripts = []

									_.forEach(choiceBenefit, function (benefitValue) {
										allBenefitsDescripts.push(_.get(benefitValue, 'benefit.descript.pt'))
									})
									syntheticBenefit.benefit.descript.pt = allBenefitsDescripts.join(', ')

									treatedCardBenefits.push(syntheticBenefit)
								})
							})

							card.treatedBenefits = treatedCardBenefits
						})
						$scope.customerCardReservation = _.get($scope.customerCards, '[0]')
					}

					if (resolved.getReservationSeats && resolved.getReservationSeats.data) {
						var reservationSeats = resolved.getReservationSeats.data[0]
						if (_.has(reservationSeats, 'minReservationAntecedence'))
							$scope.minReservationAntecedence = reservationSeats.minReservationAntecedence
						$scope.isReservationOn = !reservationSeats.disabled
						twReservationManager.setReservationSettings(reservationSeats)
						$scope.groupReservationMinPartySize =
							_.get(twReservationManager.getReservationSettings('widgetGroupReservations'), 'minPartySize') ||
							$scope.groupReservationMinPartySize
						$scope.groupReservationMaxPartySize =
							_.get(twReservationManager.getReservationSettings('widgetGroupReservations'), 'maxPartySize') ||
							$scope.groupReservationMaxPartySize
					}
					if (!$scope.isReservationOn) {
						$scope.reservation.errorReservationOn = true
						$scope.reservation.disableReservationOn = true
					}
					var reservationWidgetApp = _.get(resolved, 'getReservationWidgetApp.data[0]')
					if (reservationWidgetApp) {
						$scope.reservationWidgetApp = reservationWidgetApp
					}
					getApps()

					var venueTimezone = 'America/Sao_Paulo' //For now, same for all venues
					var todayDateStr = moment.tz(tgClock.getClock().now, venueTimezone).format('YYYY-MM-DD')
					var minDate = moment.utc(todayDateStr)
					var maxDate = moment(minDate).add(
						twReservationManager.getReservationSettings().reservationAntecedence,
						'days'
					)
					$scope.datePickerOptions = {
						minDate: minDate.toDate(),
						maxDate: maxDate.toDate(),
						showWeeks: false,
						dateDisabled: dateDisabled, //,
						// customClass: customDateClass
					}

					var todayDateDbTz = moment.tz(todayDateStr, tgClock.dbDateTz)
					var maxReservationDateDbTz = moment(todayDateDbTz).add(
						twReservationManager.getReservationSettings().reservationAntecedence,
						'days'
					)

					var availabilityPromises = {
						getAvailabilityForApp: dataFactory.getAvailabilityForApp($scope.venueId, $scope.origin.label),
					}

					if (isBradescoRequest) {
						availabilityPromises.getBradescoFutureReservations = dataFactory.getBradescoFutureReservations(
							$scope.customer._id,
							$scope.venueId
						)
					}

					$q.all(availabilityPromises)
						.then(function (promisesResults) {
							availabilitiesObject = _.get(promisesResults, 'getAvailabilityForApp.data')

							if (
								_.isEmpty(availabilitiesObject) ||
								!availabilitiesObject.available ||
								_.isEmpty(availabilitiesObject.availabilities)
							) {
								$scope.renderDatepicker = false
								$scope.isReservationTimeFull = true
								$scope.loader = false
								return
							}

							availabilitiesObject.availabilities = _.orderBy(
								availabilitiesObject.availabilities,
								['reservationDay'],
								['asc']
							)

							// If the user already has a Bradesco Celebrations reservation on a day, this day will be unavailable
							var bradescoFutureReservations = _.get(
								promisesResults,
								'getBradescoFutureReservations.data',
								[]
							)
							_.map(bradescoFutureReservations, function (dayWithBradescoReservationObj) {
								var existingDayAvailability = availabilitiesObject.availabilities.find(function (avDay) {
									if (dayWithBradescoReservationObj.day === avDay.reservationDay) return true
								})

								if (!existingDayAvailability) return // Ignore this day, despite it having a Bradesco Reservation
								if (dayWithBradescoReservationObj.hasCelebrations) {
									// This day already has Celebrations. Cannot make any other reservation here.
									existingDayAvailability.available = false

									const formattedDate = moment(dayWithBradescoReservationObj.day, 'YYYY-MM-DD')
										.locale('pt-br')
										.format('DD [de] MMMM [de] YYYY')

									$scope.messageDayWithCelebrationsReservation = formattedDate
								}
							})

							// Filling the "Reservation Date" field with the earliest day that is available
							for (var i = 0; i < availabilitiesObject.availabilities.length; i++) {
								var day = availabilitiesObject.availabilities[i]
								if (day.available) {
									$scope.reservation.reservationDate = fixDateTimeForDST(
										moment.tz(day.reservationDay, tgClock.dbDateTz)
									).toDate()
									break
								}
							}

							//This call is here at the end on purpose because the translator module resets the languague many times in an async way, so this language set must be made as late as possible
							setLanguage($location.search().lang)

							$scope.groupReservationPartySizeOptions = buildPartySizeOptions(
								$scope.groupReservationMinPartySize,
								$scope.groupReservationMaxPartySize
							)

							if ($scope.reservation.reservationDate) {
								$scope.renderDatepicker = true
								$scope.isReservationTimeFull = false
								$scope.selectDate()
							} else {
								$scope.renderDatepicker = false
								$scope.isReservationTimeFull = true
							}

							$scope.loader = false
						})
						.catch(function (response) {
							$scope.renderDatepicker = false
							$scope.isReservationTimeFull = true
							$scope.loader = false
							console.log('Error:', response)
						})
				})
				.catch(function (response) {
					$scope.renderDatepicker = false
					$scope.isReservationTimeFull = true
					$scope.loader = false
					console.log('Error:', response)
				})
		}

		function setLanguage(lang) {
			if (!lang || lang.length == 0) $scope.lang = 'pt'
			else $scope.lang = lang

			switch ($scope.lang) {
				case 'en':
					tgTranslate.use('en')
					hourI18nString = 'hour'
					minuteI18nString = 'minute'
					$scope.noteHtml = _.get($scope, 'reservationWidgetApp.noteHtml.en')
					break
				default:
					$scope.lang = 'pt'
					tgTranslate.use('pt')
					hourI18nString = 'hora'
					minuteI18nString = 'minuto'
					$scope.noteHtml = _.get($scope, 'reservationWidgetApp.noteHtml.pt')
					break
			}
		}

		function buildPartySizeOptionName(partySize) {
			if (!_.isInteger(partySize) || partySize <= 0) return

			switch ($scope.lang) {
				case 'en':
					return partySize + ' people'
				default:
					return partySize + ' pessoa' + (partySize > 1 ? 's' : '')
			}
		}
		$scope.buildPartySizeOptionName = buildPartySizeOptionName

		$scope.validateEmail = function (email) {
			if (!email) return false
			email = email.toString().replace(/\s+/g, '')
			var emailPattern = /^[^\s@]+@[^\s@]+[.][^\s@]+$/
			return emailPattern.test(email)
		}

		function validateName(name) {
			if (!name) return false
			name = name.toString().replace(/\s+/g, ' ').trim()
			var nameParts = name.split(' ')

			return !_.some(nameParts, function (namePart, index) {
				return !validateNamePart(namePart, index === 0)
			})
		}
		$scope.validateName = validateName

		function validateNamePart(namePart, isFirstName) {
			if (!namePart) return false
			namePart = namePart.toString().replace(/\s+/g, '').trim()

			var namePartPattern
			if (isFirstName) namePartPattern = /^[A-Za-z\u00C0-\u017F][A-Za-z\u00C0-\u017F0-9\".'-]+$/
			else namePartPattern = /^[A-Za-z\u00C0-\u017F0-9\".'-]+$/

			return namePartPattern.test(namePart)
		}

		$scope.validateCustomerForm = function (customerForm) {
			if (!customerForm) return false
			return (
				customerForm.$valid &&
				validateName(_.get($scope, 'customer.nome')) &&
				validateLastNameExistence(_.get($scope, 'customer.nome'))
			)
		}

		function validateLastNameExistence(name) {
			if (!name) return false
			name = name.toString().replace(/\s+/g, ' ').trim()
			var nameParts = name.split(' ')
			return nameParts.length >= 2
		}
		$scope.validateLastNameExistence = validateLastNameExistence

		$scope.isDevelopment = dataFactory.isDevelopment()

		init()
	},
])
